import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.contact');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-contact',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.contact/view.scss */
:host {
  display: block;
}

.animate-fade-in {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  section.relative {
    min-height: 300px;
  }
  section.relative h1 {
    font-size: 2rem;
  }
}`],
})
export class PageContactComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public step: number = 1;
    public submitted: boolean = false;
    public toast: any = null;

    public form: any = {
        inquiry: '',
        company: '',
        manager: '',
        number: '',
        email: '',
        content: ''
    };

    public inquiryOptions = [
        { value: 'consult', label: 'contact.step1.consult', icon: 'icon-message-circle' },
        { value: 'solution', label: 'contact.step1.solution', icon: 'icon-cpu' },
        { value: 'etc', label: 'contact.step1.etc', icon: 'icon-circle-help' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public selectInquiry(value: string) {
        this.form.inquiry = value;
        this.service.render();
    }

    public async nextStep() {
        if (this.step === 1 && !this.form.inquiry) {
            this.showToast('contact.message.inquery', 'error');
            return;
        }
        if (this.step === 2) {
            if (!this.form.company) { this.showToast('contact.message.company', 'error'); return; }
            if (!this.form.manager) { this.showToast('contact.message.manager', 'error'); return; }
            if (!this.form.number) { this.showToast('contact.message.number', 'error'); return; }
            if (!this.form.email) { this.showToast('contact.message.email', 'error'); return; }
        }
        this.step++;
        await this.service.render();
    }

    public async prevStep() {
        if (this.step > 1) {
            this.step--;
            await this.service.render();
        }
    }

    public async submit() {
        if (!this.form.content) {
            this.showToast('contact.message.content', 'error');
            return;
        }

        const { code } = await wiz.call("submit", this.form);
        if (code !== 200) {
            this.showToast('contact.message.error', 'error');
            return;
        }

        this.submitted = true;
        await this.service.render();

        setTimeout(() => {
            this.service.href("/main");
        }, 5000);
    }

    private async showToast(messageKey: string, type: string) {
        const msg = await this.service.lang.translate(messageKey);
        this.toast = { message: typeof msg === 'string' ? msg : messageKey, type };
        await this.service.render();
        setTimeout(async () => {
            this.toast = null;
            await this.service.render();
        }, 3000);
    }
}

export default PageContactComponent;